<script setup>
import {ref, computed} from 'vue'
import Button from "@/common/Button.vue"
import {useThemesStore} from "@/stores/themes"
import {useModalsStore} from "@/stores/modals"

const props = defineProps({
    id: {
        type: Number,
        required: true
    }
})

// Pinia Stores
const themesStore = useThemesStore()
const modalsStore = useModalsStore()

// --- State ---

const usage = ref(undefined)

// --- Computed ---

const sectionName = computed(() => themesStore.sectionName)

// --- Logic (Created equivalent) ---

// Only display and fetch data on the Content Types tab.
if (sectionName.value === 'content_types') {
    themesStore.getItemsUsage()
        .then((obj) => {
            usage.value = obj[props.id] || 0
        })
}

// --- Methods ---

const showPanel = () => {
    modalsStore.show({
        componentName: 'ThemesUsageModal',
        obj: {
            id: props.id
        }
    })
}
</script>

<template>
    <Button
        v-if="usage !== undefined"
        class="btn-sm p-0 px-1"
        @click.prevent.stop="showPanel"
    >
        <small>{{ usage }}</small>
    </Button>
</template>